import axios from "axios";

const API = axios.create({
    baseURL: "https://qpay.mavxnetworks.com",
    headers: {
        "x-app-id": "Web",
        "x-app-version": "1.0.0",
        "x-user-agent": navigator.userAgent,
        "Content-Type": "application/json"
    }
});

export const login = ({ mobile_no }) => API.post("/api/v1/login", { mobile_no });

export const getUserDetails = ({ session_id, code }) => API.post("/api/v1/users", { session_id, code });

export const initiatePayment = ({ session_id, user_id }) => API.post("/api/v1/payment", { session_id, user_id });